import {
    HeaderPageStyled,
    StyledTertiaryButton,
} from "features/projects/Projects.styles";
import React, { useEffect } from "react";

import GlobalConfig from "app/config/global";
import PageWrapper from "app/components/PageWrapper";
import ProjectsDashboardNav from "features/projects/project-dashboard/ProjectsDashboardNav";
import PropTypes from "prop-types";
import { useTopNavHeight } from "features/projects/useTopNavHeight";

const ProjectsDashboard = ({ handleRefreshDataClick, fixedHeaderHeight }) => {
    const topNavHeight = useTopNavHeight();

    const projectsDashboardPath = GlobalConfig.routes.projectsDashboardLanding;

    useEffect(() => {
        localStorage.removeItem("storedProjectId");
    }, []);

    return (
        <div className="selector-nav">
            <HeaderPageStyled
                top={topNavHeight}
                fixedHeaderHeight={fixedHeaderHeight}
            />
            <PageWrapper
                menuOptions={[
                    {
                        children: "Projects",
                        to: GlobalConfig.routes.projectLanding,
                    },
                    {
                        children: "Project Dashboard",
                    },
                ]}
                minHeight="max-content"
                displayFooter={false}
                paddingBottom="10px"
                breadcrumbMarginBottom={0}
                customAuthPath={projectsDashboardPath}
            >
                <ProjectsDashboardNav
                    refreshButtonElement={
                        handleRefreshDataClick ? (
                            <StyledTertiaryButton
                                aria-label="Sync"
                                leadingIcon="sync"
                                onClick={handleRefreshDataClick}
                            />
                        ) : null
                    }
                />
            </PageWrapper>
        </div>
    );
};

ProjectsDashboard.propTypes = {
    handleRefreshDataClick: PropTypes.func,
    fixedHeaderHeight: PropTypes.number
};

export default ProjectsDashboard;
